import { translation } from './en';

export const family = {
  'common': translation.common,
  'components': translation.components,
  'pages': {
    'nux': {
      'family': {
        'location': {
          'title': 'Where are you looking for care?',
          'titleJustBrowsing': 'Just browsing?\nShare your location to explore local caregivers.',
          'city': 'City',
          'state': 'State',
          'neighborhood': 'Neighborhood (optional)',
          'infoCard': {
            'title': 'How we use this info',
            'description': 'Location is used to find nearby, reliable care. Your street address will only ever be shared when you book a caregiver.'
          }
        },
        'locationErrors': {
          'errorUpdatingAddress': 'Error updating address.',
          'errorSavingSearch': 'Error saving search.',
          'errorDeletingSearch': 'Error deleting saved search.'
        },
      },
    },
    'bookingConfirmPayment': {
      'titleSame': 'Confirm payment for {{name}}',
      'subtitleSame': '{{name}} confirmed working {{date}}.',
      'subtitleMorePrefix': '{{name}} confirmed working {{date}}. To use these confirmed hours, contact',
      'subtitleLess': '{{name}} confirmed working less time on {{date}} than originally booked.',
      'confirmedTime': 'Confirmed time:',
      'useBookedHours': 'Use originally booked hours',
      'useConfirmedHours': 'Use confirmed hours',
      'startTime': 'Start Time',
      'endTime': 'End Time',
      'service': 'Service',
      'workingInterview': 'Working interview',
      'perHour': '${{rate}} /hr',
      'flatRate': 'flat rate of ${{rate}}',
      'platformFee': 'Platform Fee',
      'platformFeePercent': '3% of subtotal',
      'platformFeeTip': "Rest assured, caregivers keep 100% of their earnings with UrbanSitter's standard payouts.",
      'subtotal': 'Subtotal',
      'addTip': 'Add tip',
      'total': 'Total',
      'messageTo': 'Message to {{name}}',
      'messagePlaceholder': 'Message to {{name}}',
      'policyCertify': 'I certify that to my knowledge, this booking was for qualified services from a care provider that meets the guidelines communicated to me by my employer.',
      'viewEmployerPolicy': 'View employer policy',
      'submitting': 'Submitting...',
      'payNow': 'Pay now',
      'doubleCheck': 'Please double-check the details above before paying.',
      'cardWillCharge': "We'll charge your credit card and pay the caregiver promptly.",
      'disagreeContact': 'Disagree? Contact',
      'confirmModalTitle': 'Confirm Payment',
      'caregiverWillReceive': '{{name}} will receive ${{amount}} for this job.',
      'creditApplied': '${{amount}} in credit will be applied.',
      'cardWillBeCharged': 'Your card will be charged ${{amount}}.',
      'yesConfirm': 'Yes, Pay Now',
      'removeVoucherTitle': 'Remove discount?',
      'removeVoucherBody': 'Are you sure you want to remove this discount from the booking?',
      'removeVoucherConfirm': 'Remove discount',
      'removeDiscountAriaLabel': 'Remove discount',
      'closeModalAriaLabel': 'Close modal',
      'voucherFallback': 'Voucher #{{id}}',
      'discountRemoved': 'Discount removed.',
      'discountRemoveError': "Couldn't remove discount. Try again.",
      'submitFailed': "Couldn't confirm payment. Try again.",
      'cannotConfirmYet': 'This booking is not ready to confirm payment yet.',
      'alreadyConfirmed': 'This booking has already been confirmed.'
    },
    'jobDetail': {
      'closeModal': {
        'title': 'Close this job',
        'legend': 'Why are you closing this job?',
        'option1': "I've found a sitter through UrbanSitter",
        'option2': "I've found a sitter, but not through UrbanSitter",
        'option3': "I've decided I don't need a sitter anymore",
        'option4': 'This job post is no longer valid',
        'footer': 'Note: closing a job post will remove it from public search results and prevent caregivers from applying.',
        'submit': 'Close job',
        'validationError': 'Please select a reason.',
        'submitError': "Couldn't close job. Try again."
      }
    },
    'messageThread': {
      'messageNameHeading': 'Message {{name}}',
      'startConversation': 'Start a conversation',
      'viewPrevious': 'View previous messages',
      'typeMessage': 'Type a message to {{name}}...',
      'messageLabelTo': 'Message to {{name}}',
      'sendAriaLabel': 'Send message',
      'hiddenHeading': 'Hidden Profile',
      'hiddenBody': 'Your message cannot be sent because your profile is currently hidden. Buy a membership now or email us if you have questions: support@urbansitter.com',
      'hiddenOk': 'OK',
      'sendFailed': "Couldn't send message. Try again.",
      'bookAgain': 'Book Again',
      'book': 'Book',
      'interview': 'Interview',
      'closeModalAriaLabel': 'Close modal'
    },
    'parentBookingWizard': {
      'deferred': 'Booking step not yet implemented.',
      'frequency': {
        'heading': 'When do you need this care?',
        'justOnce': 'Just once',
        'justOnceBody': 'Send a booking request for a specific date and time',
        'recurring': 'On a recurring basis',
        'recurringBody': 'Send multiple booking requests based on a recurring schedule'
      },
      'selection': {
        'usePostHeading': 'Want to use details from an active job post?',
        'createNewBooking': 'Create a new job booking',
        'viewMore': 'View more posts',
        'heading': 'What care does your family need?',
        'recurringWithStart': '{{availability}}, starting {{date}}',
        'perHour': '${{rate}} per hour',
        'careTypes': {
          'childCare': 'Child Care',
          'childCareBody': 'Backup, occasional, part- or full-time sitters and nannies',
          'seniorCare': 'Senior Care',
          'seniorCareBody': 'Non-medical companion care',
          'petCare': 'Pet Care',
          'petCareBody': 'Dogs, cats, and other animals',
          'householdServices': 'Household Services',
          'householdServicesBody': 'Cleaning, errands, house sitting, or other services',
          'fallback': 'Care'
        }
      },
      'selectDate': {
        'agencyHeading': 'When do you need agency care?',
        'heading': 'Select Date',
        'subheading': 'Pick a start and end date/time for this booking.',
        'start': 'Start',
        'end': 'End',
        'selectTime': 'Select time',
        'interviewTimes': 'Preferred interview times: {{times}}',
        'perHour': '${{rate}} per hour',
        'fyiHeading': 'FYI',
        'fyiBody': 'One-time bookings exceeding 24 hours are not eligible for flat rate payments. Consider scheduling a recurring booking instead.',
        'unavailable': "{{name}} doesn't appear to be available during the time you requested.",
        'unavailableFallback': "This caregiver doesn't appear to be available during the time you requested.",
        'changeDate': 'Change Date',
        'sendRequestAnyway': 'Send Request Anyway',
        'seeAvailableCaregivers': 'See Available Caregivers',
        'viewAvailability': "View {{name}}'s availability",
        'bothRequired': 'Please enter both start and end date/time.',
        'endAfterStart': 'End must be after start.'
      },
      'confirmDates': {
        'heading': 'Confirm dates',
        'body': 'Add each date and time you would like this care.',
        'empty': 'No dates added yet.',
        'start': 'Start',
        'end': 'End',
        'addAnother': '+ Add another date',
        'addAtLeastOne': 'Please add at least one date.'
      },
      'photo': {
        'tooLarge': 'Photo must be under 10 MB.',
        'uploadFailed': "Couldn't upload photo. Try again.",
        'uploadPrompt': 'Upload profile photo',
        'uploading': 'Uploading…',
        'photoTips': 'Photo tips',
        'photoAlt': 'Profile'
      },
      'addDetails': {
        'agencyHeading': 'View details and book',
        'reviewHeading': 'Review details and book {{name}}',
        'dateLabel': 'Date and Time:',
        'datesLabel': 'Dates and Time:',
        'datesRange': '{{count}} dates: Between {{from}} - {{to}}',
        'starts': 'Starts {{date}}',
        'ends': 'Ends {{date}}',
        'changeDateOrTime': 'Change date or time',
        'viewAvailability': "View {{name}}'s availability",
        'describeJob': 'Describe the Job',
        'jobDescription': 'Job Description',
        'charactersRemaining': '{{count}} characters remaining',
        'descriptionPlaceholder': 'Share details about the job',
        'descriptionRequired': 'Please enter a description.',
        'noContact': 'Please do not include contact information',
        'jobIncludes': 'Job includes',
        'sweetenDeal': 'Sweeten the deal',
        'jobDetails': 'Job Details',
        'children': 'Children',
        'pets': 'Pets',
        'receivingCare': 'Receiving Care',
        'age': 'Age',
        'ages': 'Ages',
        'kidsAgesError_one': 'Tell us how old the child is.',
        'kidsAgesError_other': 'Tell us how old the children are.',
        'petTypePrompt_one': 'Click to select your pet type',
        'petTypePrompt_other': 'Click to select your pet types',
        'dog': 'Dog',
        'cat': 'Cat',
        'otherPet': 'Other',
        'paymentType': 'Payment type',
        'rateAriaLabel': 'Rate type',
        'perHourOption': 'Rate per hour',
        'flatRateOption': 'Flat rate per shift',
        'hourly': 'Hourly',
        'paymentMethod': 'Payment method',
        'creditCard': 'Credit card',
        'cash': 'Cash',
        'creditCardUnavailable': 'Credit payment unavailable',
        'cashOnly': 'Caregiver only accepts cash',
        'locationOfJob': 'Location of Job',
        'street': 'Street',
        'apt': 'Apt #',
        'city': 'City',
        'state': 'State',
        'neighborhood': 'Neighborhood',
        'zipCode': 'Zip code',
        'addressError': 'Please add or correct location information.',
        'phone': 'Phone',
        'phonePlaceholder': 'xxx-xxx-xxxx',
        'phoneError': 'Please enter a valid phone number.',
        'book': 'Book',
        'mustBeLoggedIn': 'You must be logged in to book. Please refresh and try again.',
        'datesMissing': 'Date and time are missing. Click "Change date or time" to set them.',
        'noRecurringDates': 'No recurring dates were chosen. Click "Change date or time" to add some.',
        'noCaregiverSelected': 'No caregiver selected. Please return to the caregiver search and pick someone.',
        'bookFailed': "Couldn't send booking. Try again.",
        'paywallNeedPayment': 'To complete this booking, add a payment method',
        'paywallNeedPlan': 'To complete this booking, please select a plan',
        'agencyRecipient': 'the agency',
        'caregiverRecipient': 'the caregiver',
        'minRateWarning': "{{name}}'s minimum rate is ${{min}}/hr. They may decline jobs below this rate."
      },
      'promo': {
        'title': 'Book a backup?',
        'body': 'Post this job to find backup caregivers — just in case.',
        'noThanks': 'No thanks',
        'postJob': 'Post a job'
      }
    },
    'parentProfile': {
      'toasts': {
        'linkCopied': 'Link copied to clipboard',
        'shareError': "Couldn't share. Try again.",
        'availabilityHidden': 'Availability hidden from this family.',
        'availabilityShared': 'Availability shared with this family.',
        'availabilityError': "Couldn't update availability. Try again.",
        'reportSubmitted': 'Report submitted. Thank you.',
        'removed': 'Removed.',
        'removeError': "Couldn't remove. Try again.",
        'added': 'Added.',
        'addError': "Couldn't add. Try again."
      },
      'aria': {
        'changePhoto': 'Change profile picture',
        'state': 'State',
        'report': 'Report'
      },
      'placeholders': {
        'phone': 'xxx-xxx-xxxx',
        'birthMonth': 'Birth month (1-12)',
        'birthYear': 'Birth year',
        'allergies': 'Allergies (optional)',
        'street': 'Street',
        'apt': 'Apt #',
        'city': 'City',
        'state': 'State',
        'zip': 'ZIP',
        'neighborhood': 'Neighborhood',
        'petDetails': 'Add any details such as the number, size, or personality of your pets…',
        'searchSchool': 'Search for a school',
        'searchAffiliations': 'Search affiliations',
        'searchLocalGroups': 'Search local groups'
      },
      'contacts': {
        'emergencyHeading': 'Emergency contact',
        'pediatricianHeading': 'Pediatrician'
      },
      'editKid': {
        'dependent': 'Dependent {{number}}',
        'addAnother': 'Add another dependent',
        'additionalConsiderations': 'Additional considerations'
      },
      'tooltips': {
        'hideAvailability': "If you'd prefer not to get booking requests from this family, you can hide your availability."
      },
      'buttons': {
        'hideAvailability': 'Hide Availability'
      },
      'sections': {
        'children': 'Edit dependents',
        'address': 'Home address',
        'contacts': 'Emergency contacts',
        'languages': 'Languages spoken',
        'pets': 'Edit pets',
        'localGroups': 'Local Groups'
      },
      'flagModal': {
        'title': 'Report this family',
        'inappropriateOffensive': 'This profile is inappropriate or offensive',
        'misleadingSuspicious': 'This profile is misleading or suspicious',
        'poorExperience': 'I had a poor experience with this individual',
        'discriminatory': 'This individual or their profile is discriminatory',
        'other': 'Other',
        'submit': 'Submit Report',
        'details': 'Details',
        'intro': 'Your feedback is anonymous and helps us keep the community safe.',
        'reasonRequired': 'Please choose a reason.',
        'submitError': "Couldn't submit report. Try again."
      },
      'photo': {
        'tooLarge': 'Photo must be under 10 MB.',
        'uploadFailed': "Couldn't upload photo. Try again."
      },
      'sectionTitles': {
        'children': 'Edit dependents',
        'address': 'Home address',
        'parking': 'Parking',
        'contacts': 'Emergency contacts',
        'languages': 'Languages spoken',
        'pets': 'Pets',
        'schools': 'Schools',
        'groups': 'Groups'
      }
    },
    'savedSearches': {
      'heading': 'Pick up where you left off',
      'openSearchesHeading': 'Open Searches',
      'loading': 'Loading caregivers...',
      'emptyHeading': "You haven't saved any part-time or full-time searches.",
      'emptyBody': 'When you start a new search, remember to select "Save Search" to find it here.',
      'savedOn': 'Saved {{date}}',
      'filters_one': '{{count}} filter:',
      'filters_other': '{{count}} filters:',
      'filters': '{{count}} filters:',
      'emailNotifications': 'Email notifications:',
      'notificationsLoading': 'Loading…',
      'viewSearch': 'View Search',
      'startNewHeading': 'Start a new search',
      'typeChild': 'Childcare',
      'typeSeniorLine1': 'Senior',
      'typeSeniorLine2': 'Care',
      'typePetLine1': 'Pet',
      'typePetLine2': 'Care',
      'typeHouseholdLine1': 'Household',
      'typeHouseholdLine2': 'Services',
      'deleteModalTitle': 'Why are you deleting this search?',
      'reasonPrompt': 'Select a reason',
      'reasonFoundCaregiver': 'Found a caregiver',
      'reasonNoLongerNeed': 'No longer need care',
      'reasonTooManyEmails': 'Too many emails',
      'reasonOther': 'Other',
      'closeSuccess': 'Search closed.',
      'closeError': "Couldn't close search. Try again.",
      'notificationsError': "Couldn't update notifications."
    },
    'sitters': {
      'heading': 'Search',
      'pageOf': 'Page {{current}} of {{total}}',
      'nullHeading': 'No caregivers found',
      'nullBody': 'Try adjusting your filters or expanding your search area.',
      'sortLabel': 'Sort by',
      'sort': {
        'bestMatch': 'Best match',
        'rate': 'Lowest rate',
        'reviews': 'Most reviews',
        'connections': 'Connected to me',
        'distance': 'Closest distance'
      },
      'postAJob': 'Post a job',
      'postSearchLine1': "Can't find what you're looking for?",
      'postSearchLine2': 'Post a job to the caregiver community.',
      'postToCaregivers': 'Post a job to the sitter community.',
      'results_one': '{{count}} result',
      'results_other': '{{count}} results',
      'careTypeAriaLabel': 'Care type',
      'allCaregivers': 'All caregivers',
      'saveSearchToast': {
        'success': 'Search saved.',
        'error': "Couldn't save search. Try again."
      },
      'saveSearchModal': {
        'title': 'Save Search',
        'intro': "Save your filters to quickly run this search later. We'll email you when new caregivers match.",
        'nameLabel': 'Name:',
        'namePlaceholder': 'After-school help',
        'notifyHeading': 'Get notified of new matches',
        'emailLabel': 'Email:',
        'modeLegend': 'Save type',
        'updateOption': 'Update this search',
        'newOption': 'Save as a new search',
        'appliedFilters': 'Applied Filters ({{count}})',
        'typeOfCare': 'Type of care:',
        'typeOfJob': 'Type of job:',
        'locationLabel': 'Location:',
        'distanceLabel': 'Distance:',
        'distanceMiles_one': '{{count}} mile',
        'distanceMiles_other': '{{count}} miles',
        'numberReceivingCare': 'Number receiving care:',
        'rateLabel': 'Rate:',
        'rateUnder': 'under ${{rate}}/hr'
      },
      'availableDate': {
        'label': 'Available:',
        'startingLabel': 'Starting:',
        'endingLabel': 'Ending:',
        'change': 'Change',
        'clear': 'Clear',
        'endAfterStart': 'End time must be after start time.'
      }
    },
    'sittersEditAvailability': {
      'title': 'Select the blocks of time you need',
      'generallyAvailable': 'Generally available:',
      'showOnlyExactMatches': 'Show only exact matches',
      'am': 'AM',
      'pm': 'PM',
      'night': 'Night',
      'morningDescription': 'early morning to mid-day',
      'afternoonDescription': 'mid-day to evening',
      'nightDescription': 'evening to nighttime',
      'morningAriaLabel': 'Require {{day}} morning availability',
      'afternoonAriaLabel': 'Require {{day}} afternoon availability',
      'nightAriaLabel': 'Require {{day}} night availability',
      'postJobPrefix': 'To add more specific times,',
      'postJobLink': 'post a job to the sitter community.'
    },
    'settings': {
      'sections': {
        'accountBasics': 'Account Basics',
        'communication': 'Communication',
        'socialConnections': 'Social Connections'
      },
      'rowHeadings': {
        'membershipPlan': 'Membership plan',
        'nextBillingDate': 'Next Billing Date',
        'identityCheck': 'Identity check',
        'email': 'Email',
        'password': 'Password',
        'mobilePhone': 'Mobile phone',
        'newsletter': 'Newsletter',
        'friendsOnUS': 'Friends on UrbanSitter',
        'schools': 'Schools',
        'affiliations': 'Affiliations',
        'localGroups': 'Local Groups',
        'savedSearches': 'Saved Searches',
        'facebook': 'Facebook',
        'google': 'Google'
      },
      'fields': {
        'emailAriaLabel': 'Email address',
        'currentPasswordAriaLabel': 'Current password',
        'currentPasswordPlaceholder': 'Verify current password',
        'newPasswordPlaceholder': 'Enter your new password',
        'repeatPasswordPlaceholder': 'Repeat your new password'
      },
      'loading': 'Loading...',
      'savedToast': 'Settings saved.',
      'saveError': "Couldn't save settings. Try again.",
      'facebookSdkUnavailable': 'Facebook SDK not available. Please try again.',
      'connectFacebook': 'Connect with Facebook',
      'facebookConnectBody': 'Connect to see recommendations from people you know.',
      'google': {
        'linkFailed': 'Google account linking failed.',
        'linkSuccess': 'Google successfully connected.',
        'linkError': "Couldn't link Google. Try again."
      },
      'planModal': {
        'cancelHeading': 'Cancel membership',
        'cancelBody': 'Are you sure you want to cancel your membership? You will lose access at the end of your current billing cycle.',
        'cancelCta': 'Cancel membership',
        'changeHeading': 'Change membership plan',
        'changeIntro': 'Pick a new plan below.',
        'termsBody': 'Auto-renewal, payment, subscription, cancellation, and refund policies apply.',
        'termsCheckbox': 'I have reviewed and agree to these policies.',
        'acceptTerms': 'You must accept the terms to continue.',
        'planUpdated': 'Plan updated.',
        'planUpdateError': "Couldn't update plan. Try again."
      },
      'privacy': {
        'heading': 'Privacy',
        'description': 'Control what other UrbanSitter members can see about you.',
        'showBookedCaregivers': 'Show the caregivers I have booked on my public profile.'
      },
      'upsell': {
        'heading': 'Get more from UrbanSitter',
        'upgrade': 'Upgrade now',
        'getAPlan': 'Get a plan',
        'fallbackBullet1': 'Message and book sitters faster.',
        'fallbackBullet2': 'Unlock private notes, recommendations, and more.',
        'fallbackBullet3': 'Cancel anytime.'
      }
    },
    'calendar': {
      'lastUpdate': 'Last updated {{date}}',
      'today': 'Today',
      'previousLabel': 'Previous {{unit}}',
      'nextLabel': 'Next {{unit}}',
      'unitDay': 'day',
      'unitWeek': 'week',
      'unitMonth': 'month',
      'viewDay': 'Day',
      'viewWeek': 'Week',
      'viewMonth': 'Month',
      'settingsAria': 'Calendar settings',
      'noUpcoming': 'No upcoming availability.',
      'noUpcomingFor': '{{name}} does not show availability at this time. Send a request to confirm availability.',
      'upcoming': 'Upcoming',
      'available': 'Available',
      'availableShort': 'Avail',
      'booking': 'Booking',
      'booked': 'Booked',
      'midnightPlus': 'midnight+',
      'moreEntries': '+{{count}} more',
      'previousMonth': 'Previous month',
      'nextMonth': 'Next month',
      'timeGridAria': 'Time grid',
      'goToDay': 'Go to day',
      'addOnDateAriaLabel': 'Add on {{date}}',
      'ratingAria': 'Rating {{rating}}',
      'bookingRequest': 'Booking request',
      'upcomingBooking': 'Upcoming booking',
      'profilePhotoFor': '{{name}} profile',
      'ratePerHour': '${{rate}}/hr',
      'childCount_one': '{{count}} child',
      'childCount_other': '{{count}} children',
      'kidsAgesParenthetical': '({{ages}})',
      'payVia': 'Pay via {{paymentType}}',
      'viewRequest': 'View Request',
      'viewBooking': 'View Booking',
      'requestABooking': 'Request a Booking',
      'message': 'Message',
      'interview': 'Interview',
      'respondsIn_one': 'Responds in 1 hour',
      'respondsIn_other': 'Responds in {{count}} hours',
      'reviewsAndRepeats': '{{reviews}} | {{repeats}}',
      'reviewsCount_one': '1 review',
      'reviewsCount_other': '{{count}} reviews',
      'repeatFamiliesCount_one': '1 repeat family',
      'repeatFamiliesCount_other': '{{count}} repeat families',
      'loading': 'Loading...'
    },
    'sitterProfile': {
      'availability': {
        'heading': 'Availability',
        'snapshotHeading': 'Job seeking snapshot:',
        'takingBreak': 'Taking a break?',
        'updated': 'Availability updated'
      },
      'rates': translation.components.sitterProfile.rates,
      'labels': translation.components.sitterProfile.labels,
      'modals': {
        'editLanguages': 'Edit languages',
        'editTeachingSkills': 'Edit teaching skills',
        'editSpecialExperience': 'Edit special experience',
        'editSpecialServices': 'Edit special services',
        'editSpecialSituations': 'Edit special situations',
        'editOtherServices': 'Edit other services',
        'editRates': 'Edit rates',
        'editLocation': 'Edit location',
        'editCertifications': 'Edit certifications',
        'editEducation': 'Edit education',
        'editAgeExperience': 'Edit your experience with different age groups',
        'covidConsent': 'COVID-19 consent'
      }
    }
  },
  'notifications': {
    'feedback': {
      'success': 'Thanks for your feedback!',
    },
    'facebook': {
      'success': 'Facebook successfully connected.',
      'error': 'Unable to link Facebook account. Please try again or contact support.',
    },
  },
  'validation': translation.validation,
}
